import { format } from "date-fns";
import { es } from "date-fns/locale";

export const formatDate = (dateISO) => {
  const date = new Date(dateISO);

  const nameDay = format(date, "EEE", { locale: es });
  const day = format(date, "dd");
  const month = format(date, "MMM", { locale: es });
  const year = format(date, "yyyy");
  const time = format(date, "HH:mm:ss");

  const nameDayCap = nameDay.charAt(0).toUpperCase() + nameDay.slice(1);
  const monthCap = month.charAt(0).toUpperCase() + month.slice(1);

  const timezoneOffset = -date.getTimezoneOffset() / 60;
  const gmt = `(GMT ${timezoneOffset >= 0 ? "+" : ""}${timezoneOffset})`;

  return `${nameDayCap}, ${day} ${monthCap} ${year} ${time} ${gmt}`;
};

export const completeResponse = (response) => {
  let status;
  let message;
  let error = response?.error || false;

  if (response.status_code >= 200 && !error) {
    status = "success";
    message = response.message ? response.message : "Éxito";
  } else if (response.status_code === 422) {
    status = "warning";
    message = response.message ? response.message : "Advertencia";
  } else if (response.status_code >= 400 && response.status_code < 600) {
    status = "danger";
    message = response.message
      ? response.message
      : "Ha ocurrido un error al realizar la acción. Vuelva a intentar más tarde";
  } else {
    status = "info";
    message = response.message ? response.message : "Mensaje de Información";
  }
  return { ...response, status, message };
};
